
import Schema from 'AppReact/schema';
import { category } from 'types';

export default {
  isOpen: Schema('boolean', 'primitive', { defaultValue: false }),
  categories: Schema(category, 'array', { defaultValue: [] }),
  selectedCategoryId: Schema('integer', 'primitive-nullable', { defaultValue: null }),
  selectedParentId: Schema('integer', 'primitive-nullable', { defaultValue: null }),
  containerRef: Schema({}, 'object', { defaultValue: null }),
}

